import React from 'react';
import { TrendingUp, TrendingDown, Target, DollarSign, FileText, AlertTriangle } from 'lucide-react';
import { formatRevenue } from './Shared/AnalyticsComponents';

const KPIStatsGrid = ({ metrics }) => {
    const kpiCards = [
        metrics?.win_rate !== undefined && {
            icon: Target,
            label: "Win Rate",
            value: `${(metrics.win_rate ?? 0).toFixed(1)}%`,
            change: "+5.2%",
            up: true,
            color: "#FF5526"
        },
        metrics?.total_revenue !== undefined && {
            icon: DollarSign,
            label: "Pipeline Value",
            value: formatRevenue(metrics.total_revenue),
            change: "+23%",
            up: true,
            color: "#059669"
        },
        metrics?.active_rfps !== undefined && {
            icon: FileText,
            label: "Active RFPs",
            value: metrics.active_rfps,
            change: "+12 YTD",
            up: true,
            color: "#D97706"
        },
        metrics?.risk_index && {
            icon: AlertTriangle,
            label: "Risk Index",
            value: metrics.risk_index,
            change: "Stable",
            up: true,
            color: metrics.risk_index === 'Low' ? "#059669" : metrics.risk_index === 'Medium' ? "#D97706" : "#DC2626"
        }
    ].filter(Boolean);

    return (
        <div className={`kpi-stats-grid grid-cols-${kpiCards.length}`}>
            {kpiCards.map((s) => (
                <div className="stat-card" key={s.label}>
                    <div className="stat-label-row">
                        <div className="stat-icon-pill" style={{ backgroundColor: s.color + "15" }}>
                            <s.icon className="w-4 h-4" style={{ color: s.color }} />
                        </div>
                        <span className="stat-label">{s.label}</span>
                    </div>
                    <div className="stat-value-row">
                        <span className="stat-value">{s.value}</span>
                        <span className={`stat-trend ${s.up ? 'trend-positive' : 'trend-negative'}`}>
                            {s.up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                            {s.change}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default KPIStatsGrid;
